import PageHero from "../components/sections/PageHero";
import SectionLabel from "../components/ui/SectionLabel";

const cardStyle: React.CSSProperties = {
  background: "#0E0E0E",
  border: "1px solid rgba(212,168,67,0.18)",
  borderRadius: 4,
  padding: "32px 28px",
};

const bodyStyle: React.CSSProperties = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 15,
  color: "#8B8378",
  lineHeight: 1.8,
  fontWeight: 300,
};

const PrivacyPolicy = () => (
  <>
    <PageHero
      label="LEGAL"
      title="Privacy"
      titleAccent="policy."
      subtitle="A simple explanation of what information we collect, why we collect it, and how to reach us about your data."
    />

    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <div style={{ marginBottom: 32 }}>
          <SectionLabel text="LAST UPDATED" />
          <p style={{ ...bodyStyle, marginTop: 16 }}>March 20, 2026</p>
        </div>

        <div style={{ display: "grid", gap: 20 }}>
          {[
            {
              title: "What we collect",
              body:
                "When you contact Obsidian Web Labs, we may collect the information you choose to share with us, including your name, company, email address, phone number, project details, and any supporting notes you submit through our website or email channels.",
            },
            {
              title: "How we use it",
              body:
                "We use submitted information to respond to enquiries, prepare proposals, understand project needs, improve our website experience, and maintain internal records of active business conversations. We do not sell your information.",
            },
            {
              title: "Storage and retention",
              body:
                "This website currently uses client-side storage for certain demo-style enquiry flows. If you send us information directly, we retain it only for as long as needed to respond, evaluate a project opportunity, meet legal obligations, or maintain our business records.",
            },
            {
              title: "Sharing",
              body:
                "We only share your information when it is necessary to deliver services, comply with legal requirements, protect our rights, or work with trusted vendors supporting our operations. We expect those partners to protect the information appropriately.",
            },
            {
              title: "Your choices",
              body:
                "You can ask us to update, correct, or delete the personal information you have shared with us, subject to any legal or contractual obligations that require retention.",
            },
            {
              title: "Contact",
              body:
                "For privacy-related requests, email obsidianweblabs@gmail.com or call +91 63933 87138. If this policy changes, we will update this page with the new effective date.",
            },
          ].map((section) => (
            <article key={section.title} style={cardStyle}>
              <h2
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 500,
                  fontSize: 34,
                  color: "#F8F4EC",
                  marginBottom: 12,
                }}
              >
                {section.title}
              </h2>
              <p style={bodyStyle}>{section.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default PrivacyPolicy;
